export default __webpack_public_path__ + "static/media/basiercircle-semibold-webfont.01d47e7a.ttf";